import { UIColor } from "uicore-ts"

export class BSColor extends UIColor {
    
    
    
    // --- Primary (Blue) ---
    static get primary() {
        return new BSColor("#0d6efd")
    }
    
    static get primaryHover() {
        return new BSColor("#0b5ed7")
    }
    
    static get primaryActive() {
        return new BSColor("#0a58ca")
    }
    
    static get primaryBorder() {
        return new BSColor("#0d6efd")
    }
    
    static get primaryBorderHover() {
        return new BSColor("#0a58ca")
    }
    
    static get primaryBorderActive() {
        return new BSColor("#0a53be")
    }
    
    static get primaryShadow() {
        return new BSColor("rgba(49, 132, 253, 0.5)")
    }
    
    // --- Secondary (Gray) ---
    static get secondary() {
        return new BSColor("#6c757d")
    }
    
    static get secondaryHover() {
        return new BSColor("#5c636a")
    }
    
    static get secondaryActive() {
        return new BSColor("#565e64")
    }
    
    static get secondaryBorder() {
        return new BSColor("#6c757d")
    }
    
    static get secondaryBorderHover() {
        return new BSColor("#565e64")
    }
    
    static get secondaryBorderActive() {
        return new BSColor("#51585e")
    }
    
    static get secondaryShadow() {
        return new BSColor("rgba(130, 138, 145, 0.5)")
    }
    
    // --- Success (Green) ---
    static get success() {
        return new BSColor("#198754")
    }
    
    static get successHover() {
        return new BSColor("#157347")
    }
    
    static get successActive() {
        return new BSColor("#146c43")
    }
    
    static get successBorder() {
        return new BSColor("#198754")
    }
    
    static get successBorderHover() {
        return new BSColor("#146c43")
    }
    
    static get successBorderActive() {
        return new BSColor("#13653f")
    }
    
    static get successShadow() {
        return new BSColor("rgba(60, 153, 110, 0.5)")
    }
    
    // --- Danger (Red) ---
    static get danger() {
        return new BSColor("#dc3545")
    }
    
    static get dangerHover() {
        return new BSColor("#bb2d3b")
    }
    
    static get dangerActive() {
        return new BSColor("#b02a37")
    }
    
    static get dangerBorder() {
        return new BSColor("#dc3545")
    }
    
    static get dangerBorderHover() {
        return new BSColor("#b02a37")
    }
    
    static get dangerBorderActive() {
        return new BSColor("#a52834")
    }
    
    static get dangerShadow() {
        return new BSColor("rgba(225, 83, 97, 0.5)")
    }
    
    static get warningOrange() {
        return new BSColor("#f59e0b")
    }
    
    // --- Warning (Yellow) ---
    static get warning() {
        return new BSColor("#ffc107")
    }
    
    static get warningHover() {
        return new BSColor("#ffca2c")
    }
    
    static get warningActive() {
        return new BSColor("#ffcd39")
    }
    
    static get warningBorder() {
        return new BSColor("#ffc107")
    }
    
    static get warningBorderHover() {
        return new BSColor("#ffc720")
    }
    
    static get warningBorderActive() {
        return new BSColor("#ffc720")
    }
    
    static get warningShadow() {
        return new BSColor("rgba(217, 164, 6, 0.5)")
    }
    
    // --- Info (Cyan) ---
    static get info() {
        return new BSColor("#0dcaf0")
    }
    
    static get infoHover() {
        return new BSColor("#31d2f2")
    }
    
    static get infoActive() {
        return new BSColor("#3dd5f3")
    }
    
    static get infoBorder() {
        return new BSColor("#0dcaf0")
    }
    
    static get infoBorderHover() {
        return new BSColor("#25cff2")
    }
    
    static get infoBorderActive() {
        return new BSColor("#25cff2")
    }
    
    static get infoShadow() {
        return new BSColor("rgba(11, 172, 204, 0.5)")
    }
    
    // --- Light ---
    static get light() {
        return new BSColor("#f8f9fa")
    }
    
    static get lightHover() {
        return new BSColor("#e2e6ea")
    }
    
    static get lightActive() {
        return new BSColor("#dae0e5")
    }
    
    static get lightBorder() {
        return new BSColor("#f8f9fa")
    }
    
    static get lightBorderHover() {
        return new BSColor("#dae0e5")
    }
    
    static get lightBorderActive() {
        return new BSColor("#d3d9df")
    }
    
    static get lightShadow() {
        return new BSColor("rgba(211, 212, 213, 0.5)")
    }
    
    // --- Dark ---
    static get dark() {
        return new BSColor("#212529")
    }
    
    static get darkHover() {
        return new BSColor("#424649")
    }
    
    static get darkActive() {
        return new BSColor("#4d5154")
    }
    
    static get darkBorder() {
        return new BSColor("#212529")
    }
    
    static get darkBorderHover() {
        return new BSColor("#373b3e")
    }
    
    static get darkBorderActive() {
        return new BSColor("#373b3e")
    }
    
    static get darkShadow() {
        return new BSColor("rgba(66, 70, 73, 0.5)")
    }
    
    // --- Text Colors ---
    static get textWhite() {
        return new BSColor("#ffffff")
    }
    
    static get textBlack() {
        return new BSColor("#000000")
    }
    
    static get textMuted(): BSColor {
        return new BSColor("#6c757d")
    }
    
    static get disabled() {
        return new BSColor("#e9ecef")
    }
    
    
    // Bootstrap 5 default focus ring: $primary with .25 opacity
    static get focusRing() {
        return new BSColor("rgba(13, 110, 253, 0.25)")
    }
    
    // Standard border color usually used on cards and inputs (#dee2e6)
    static get borderLight() {
        return new BSColor("#dee2e6")
    }
    
    // Lighter background for hover states (#f8f9fa)
    static get backgroundLight() {
        return new BSColor("#f8f9fa")
    }
    
    
    
    
    
    
    
}








